<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #SHOWSTATUS>
      <order-tracker v-if="statusId" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getTimeoutUnsent } from "@/api/analysis/timeoutUnsent";
import { getCountry } from "@/api/system/country";
import { getSelectType } from "@/api/public";
import { getUser } from "@/api/user/internal";
import { getChannel } from "@/api/tracker/channel";
import { getAgent } from "@/api/tracker/agent";
import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/order_tracker";
import cTable from "@/base/common/index";
import { getCity } from "@/api/system/city";

// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "timeoutUnsent",
  components: {
    cTable,
    orderTracker,
  },
  methods: {
    isShow() {
      return this.$route.name != "delayShipments";
    },
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: (p) => {
          if (!this.isShow()) p["deliver"] = "FFC";

          return getTimeoutUnsent(p);
        },
        getCountry,
        getAgent,
        getAllClient,
        getChannel,
        getSelectType,
      },
      config: {
        height: 630,
      },
      modals: {
        showstatus: {
          contentSlot: "SHOWSTATUS",
          methods: {
            cancel: ({ close }) => {
              this.statusId = "";
            },
          },
          footer: {
            show: false,
          },
        },
      },
      header: {
        searchs: [
          {
            key: "frequency",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("DeliveryTimes");
            },
            clearable: true,
            options: [],
            default: Number(this.$route.query.frequency) || "",
            // config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
            methods: {
              async "on-change"({ value, field, fields, searchForm }) {
                let country = field.options.find(
                  (t) => t.code === searchForm.to_country
                );
                fields.forEach(async (el) => {
                  if (el.key == "city_id") {
                    if (country) {
                      let res = (await getCity({ country_id: country.id })).data
                        .payload.rows;
                      el.options = res;
                    } else {
                      el.options = [];
                    }
                    searchForm[el.key] = "";
                    return;
                  }
                });
              },
            },
          },
          {
            key: "city_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("city_name");
            },
            clearable: true,
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              multiple: true,
              "max-tag-count": 1,
              style: "width:150px",
            },
            show: this.isShow,
          },
          {
            key: "cod_type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("order_type");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            methods: {
              async list({ field, searchForm }) {
                field.options = await this.$sel.getData("COD_TYPE");
                this.$forceUpdate();
              },
            },
          },
          {
            key: "deliver",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("localFaction");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "agent_name" },
            bind: {
              style: "width:140px",
            },
            show: this.isShow,
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "tracker_code",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("tracker_code");
            },
            clearable: true,
            options: [],
            config: { label: "tracker_code", value: "tracker_code" },
            bind: {
              style: "width:140px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "center",
          width: 180,
          tooltip: false,
          copy: true,
          component: "Button",
          header: {
            copy: true,
          },
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render: ({ value }) => {
              return value;
            },
            click({ row }) {
              // console.log("this", this);
              this.$page.$parent.statusId = row.airway_number;
              this.$page
                .getModal("showstatus")
                .setTitle(
                  row.airway_number + "(" + this.$t("trajectory") + ")"
                );
              this.$page.getModal("showstatus").open(row.airway_number);
            },
          },
        },
        {
          name: () => this.$tz("城市"),
          key: "city_name",
        },
        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center",
        },
        {
          name: () => this.$t("should_delivery_time"),
          key: "should_delivery_time",
          width: 180,
        },
        {
          name: () => this.$t("DeliveryTimes"),
          key: "frequency",
        },
        {
          name: () => this.$t("outTimeday"),
          align: "center",
          key: "outTimeNumber",
        },
        {
          name: () => this.$t("order_type"),
          key: "cod_type",
        },
        {
          name: () => this.$t("codAmount"),
          align: "center",
          key: "cod_amount",
        },

        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "client_name",
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
        },
        {
          name: () => this.$t("new_tracker_code"),
          width: 100,
          key: "status",
        },
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "to_country")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "deliver")
        item.options = (
          await getAgent({
            agent_type: "bag",
            status: "YES",
            types: "DELIVERY",
          })
        ).data.payload.rows;
      if (item.key === "frequency")
        item.options = (
          await getSelectType(["TIME_OUT_NOT_DELIVERY"])
        ).data.payload["TIME_OUT_NOT_DELIVERY"];
      if (item.key === "tracker_code")
        item.options = (await getStatus({ pageSize: 9999 })).data.payload.rows;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
  },
};
</script>
